import styled from '@emotion/styled'

export const TablePaginationWrapper = styled.section`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`

export const SideActions = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
`
